// extracted by mini-css-extract-plugin
export default {"info-panel":"InfoPanel_info-panel__6Fi-5","fade":"InfoPanel_fade__MHv8m","info-panel__back-btn":"InfoPanel_info-panel__back-btn__KfXQ5"};